import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import infoIcon from "../assets/images/infobtnblue.svg";
import CKeditorComponent from "../component/common-component/CKeditorComponent";
import { commonservices } from "../services/CommonServices";
import { CONFIG_COMPONENT_NAME } from "../services/configComponent";

const AddEditParameterModal = (props) => {
  const [Newmachineparameter, setNewmachineparameter] = useState({
    parakey: "",
    paratype: "",
    paravalueselection: "",
    details: "",
    errors: {
      parakey: "",
      paratype: "",
      paravalueselection: "",
      details: "",
      ValidationRules: [
        {
          FieldName: "parakey",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "paratype",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "details",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  const handleSubmit1 = async (e) => {
    e.preventDefault();

    let errors = Newmachineparameter.errors;
    if (
      Newmachineparameter.paratype !== "Dropdown Single Select" &&
      Newmachineparameter.paratype !== "Dropdown Multiple Select"
    ) {
      errors.paravalueselection = "";
    }
    // if (
    //   (Newmachineparameter.paratype === "Dropdown Single Select" ||
    //     Newmachineparameter.paratype === "Dropdown Multiple Select") &&
    //   !Newmachineparameter.paravalueselection
    // ) {
    //   errors.paravalueselection =
    //     "Selection value is required for dropdown types";
    // } else {
    //   errors.paravalueselection = "";
    // }
    if (
      Newmachineparameter.paratype === "Dropdown Single Select" ||
      Newmachineparameter.paratype === "Dropdown Multiple Select"
    ) {
      let CheckJson = commonservices.IsValidJson(
        Newmachineparameter?.paravalueselection
      );
      if (CheckJson) {
        errors.paravalueselection = "";
      } else {
        errors.paravalueselection = "Enter valid Json format";
      }
    }
    let obj = commonservices.fnCheckValidationOfObject(Newmachineparameter);
    setNewmachineparameter({
      ...obj.obj,
    });
    if (obj.isValid && !errors.paravalueselection) {
      let updatedType = [];
      let body = {
        parakey: Newmachineparameter?.parakey,
        paratype: Newmachineparameter?.paratype,
        paravalueselection: Newmachineparameter?.paravalueselection,
        details: Newmachineparameter?.details,
      };
      if (props?.type === "Add") {
        if (props.data?.machineconfigparameter?.length > 0) {
          props.setInput({
            ...props.data,
            machineconfigparameter: [
              ...props.data?.machineconfigparameter,
              body,
            ],
          });
        } else {
          props.setInput({
            ...props.data,
            machineconfigparameter: [body],
          });
        }
      } else {
        updatedType = [...props.data.machineconfigparameter];
        updatedType[props?.ParameterModalIndex].parakey =
          Newmachineparameter?.parakey;
        updatedType[props?.ParameterModalIndex].paratype =
          Newmachineparameter?.paratype;
        updatedType[props?.ParameterModalIndex].paravalueselection =
          Newmachineparameter?.paravalueselection;
        updatedType[props?.ParameterModalIndex].details =
          Newmachineparameter?.details;
        props.setInput({
          ...props.data,
          machineconfigparameter: updatedType,
        });
      }

      const hasValidParaType = props.data.machineconfigparameter?.filter(
        (item) => {
          if (!CONFIG_COMPONENT_NAME[item?.paratype]) {
            return item;
          }
        }
      );
      props.setInput({
        ...props?.data,
        machineconfigparameter:
          props?.type === "Add"
            ? props.data?.machineconfigparameter?.length > 0
              ? [...props.data?.machineconfigparameter, body]
              : [body]
            : updatedType,
        parametershow: hasValidParaType?.length > 0 ? false : true,
      });
      props.onHide();
    }
  };

  useEffect(() => {
    if (
      props?.data?.machineconfigparameter?.length > 0 &&
      props?.type === "Edit"
    ) {
      props?.data?.machineconfigparameter?.forEach((element, index) => {
        if (index === props?.ParameterModalIndex) {
          setNewmachineparameter({
            ...Newmachineparameter,
            parakey: element.parakey,
            paratype: element.paratype,
            paravalueselection: element.paravalueselection,
            details: element.details,
          });
        }
      });
    }
  }, [props?.data]);

  const fnInputChange = (value, tag) => {
    if (value) {
      setNewmachineparameter({
        ...Newmachineparameter,
        [tag]: value,
        errors: {
          ...Newmachineparameter.errors,
          [tag]: "",
        },
      });
    } else {
      setNewmachineparameter({
        ...Newmachineparameter,
        [tag]: "",
      });
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event?.preventDefault();
        handleSubmit1(event);
      }
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  });

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props?.type} Parameter
        </Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          handleSubmit1(e);
        }}
      >
        <Modal.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Name<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    maxLength={67}
                    className="common-input"
                    value={Newmachineparameter?.parakey}
                    onChange={(e) => fnInputChange(e.target.value, "parakey")}
                    isInvalid={Newmachineparameter?.errors?.parakey}
                  />
                  {Newmachineparameter.errors.parakey && (
                    <Form.Control.Feedback type="invalid">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={Newmachineparameter.errors.parakey}
                        />
                      </span>
                    </Form.Control.Feedback>
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Type<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <div className="position-relative">
                  <Form.Select
                    className="common-select contact-dropdown-size m-0"
                    value={Newmachineparameter?.paratype}
                    onChange={(e) => fnInputChange(e.target.value, "paratype")}
                    isInvalid={Newmachineparameter?.errors?.paratype}
                  >
                    <option value="">Select</option>
                    {props?.ProjectTermList.InputType?.length > 0 &&
                      props?.ProjectTermList.InputType?.map(
                        (item_cd, index_cd) => (
                          <option key={index_cd} value={item_cd?.term}>
                            {item_cd?.term}
                          </option>
                        )
                      )}
                  </Form.Select>
                  {Newmachineparameter.errors.paratype && (
                    <Form.Control.Feedback type="invalid">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={Newmachineparameter.errors.paratype}
                        />
                      </span>
                    </Form.Control.Feedback>
                  )}
                </div>
              </Form.Group>
            </Col>
            {(Newmachineparameter?.paratype === "Dropdown Single Select" ||
              Newmachineparameter?.paratype === "Dropdown Multiple Select") && (
              <Col md={12}>
                <Form.Group className="form-group mb16">
                  <Form.Label className="common-label">
                    Selection Value (As a Array List)
                    <span className="ms-1 red-color-text">*</span>
                  </Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      as="textarea"
                      placeholder={`["1","2","3"]`}
                      className="common-input"
                      value={Newmachineparameter?.paravalueselection}
                      onChange={(e) => {
                        if (e.target.value.startsWith("[")) {
                          setNewmachineparameter({
                            ...Newmachineparameter,
                            paravalueselection: e.target.value,
                          });
                        } else {
                          setNewmachineparameter({
                            ...Newmachineparameter,
                            paravalueselection: "",
                          });
                        }
                      }}
                      isInvalid={
                        Newmachineparameter?.errors?.paravalueselection
                      }
                    />
                    {Newmachineparameter.errors.paravalueselection && (
                      <Form.Control.Feedback type="invalid">
                        <span className="error-message-icon">
                          <img
                            src={infoIcon}
                            alt="infoIcon"
                            title={
                              Newmachineparameter.errors.paravalueselection
                            }
                          />
                        </span>
                      </Form.Control.Feedback>
                    )}
                  </div>
                </Form.Group>
              </Col>
            )}
            <Col md={12}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Detail<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <div className="position-relative">
                  <div
                    className={`${
                      Newmachineparameter.errors.details && "error-border-line"
                    }`}
                  >
                    <CKeditorComponent
                      onChange={(e) => fnInputChange(e, "details")}
                      tag="details"
                      value={Newmachineparameter?.details}
                    />
                  </div>
                  {Newmachineparameter.errors.details && (
                    <p className="error-line">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={Newmachineparameter.errors.details}
                        />
                      </span>
                    </p>
                  )}
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <button className="grey-btn w-auto" onClick={props.onHide}>
            Close
          </button>
          <button className="blue-btn w-auto" type="submit">
            Save
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddEditParameterModal;
